import { COMPANY, LEGAL_VERSION } from '../constants/company';

const C = COMPANY;
const SERVICE = 'MARQIT Analytics';

// Public legal documents of the service. Each one is a list of sections; a section is a heading and
// paragraphs. Keep LEGAL_VERSION in sync when the meaning of a text changes.
export const LEGAL_DOCS = {
  offer: {
    path: '/legal/offer',
    title: 'Публичная оферта',
    subtitle: `Договор на предоставление доступа к сервису ${SERVICE}`,
    sections: [
      {
        h: '1. Общие положения',
        p: [
          `1.1. ${C.fullName} (ИНН ${C.inn}, ОГРН ${C.ogrn}), далее «Исполнитель», предлагает любому лицу, далее «Пользователь», заключить договор на предоставление доступа к онлайн-сервису ${SERVICE} (сайт ${C.site}), далее «Сервис», на условиях этой оферты.`,
          '1.2. Оферта является публичной в соответствии со статьёй 437 Гражданского кодекса РФ. Полным и безоговорочным принятием (акцептом) оферты считается регистрация в Сервисе с отметкой о согласии с офертой либо оплата доступа.',
          '1.3. Сервис предназначен для индивидуальных предпринимателей и организаций, продающих товары на маркетплейсах, и используется в предпринимательских целях.',
          `1.4. Сервис является независимым продуктом Исполнителя. Он не является продуктом, официальным представительством или подразделением Wildberries, Ozon, Яндекс Маркета и иных маркетплейсов. Названия маркетплейсов упоминаются только для описания совместимости.`,
        ],
      },
      {
        h: '2. Предмет договора',
        p: [
          '2.1. Исполнитель предоставляет Пользователю право использования Сервиса через интернет на условиях простой (неисключительной) лицензии, а Пользователь оплачивает доступ по выбранному тарифу.',
          '2.2. Сервис по API-ключу, который Пользователь сам выпускает в личном кабинете маркетплейса, загружает данные о продажах, возвратах, финансовых отчётах, рекламе, остатках и иных показателях магазина Пользователя и показывает аналитику: выручку, расходы, прибыль, маржу, остатки и прочие расчётные показатели.',
          '2.3. Сервис только читает данные магазина. Он не изменяет цены, карточки товаров, остатки, рекламные кампании и иные настройки в кабинете маркетплейса.',
        ],
      },
      {
        h: '3. Регистрация и API-ключи',
        p: [
          '3.1. Для работы с Сервисом Пользователь регистрируется по адресу электронной почты и паролем. Пользователь отвечает за сохранность пароля и за действия, совершённые под его учётной записью.',
          '3.2. Пользователь подключает магазин, передавая в Сервис API-ключ маркетплейса. Ключ должен быть выпущен Пользователем самостоятельно и с правами только на чтение тех данных, которые нужны Сервису. Для подключения рекомендуется сервисный токен, если Сервис доступен в каталоге решений маркетплейса.',
          '3.3. Исполнитель хранит API-ключи в зашифрованном виде и использует их только для загрузки данных магазина Пользователя. Пользователь вправе в любой момент удалить ключ в Сервисе или отозвать его в кабинете маркетплейса.',
          '3.4. Один магазин маркетплейса может быть подключён только к одной учётной записи Сервиса.',
        ],
      },
      {
        h: '4. Пробный период и оплата',
        p: [
          '4.1. После регистрации Пользователю может предоставляться бесплатный пробный период. Срок и ограничения пробного периода указываются в Сервисе. Во время пробного периода часть функций, например выгрузка отчётов, может быть недоступна.',
          '4.2. Стоимость и состав тарифов указаны в разделе «Тарифы» Сервиса и в счёте на оплату. НДС не облагается или указывается в счёте в соответствии с применяемой Исполнителем системой налогообложения.',
          '4.3. Оплата производится безналичным переводом на расчётный счёт Исполнителя по выставленному счёту. Доступ открывается после поступления оплаты на срок оплаченного периода.',
          '4.4. Исполнитель вправе изменять тарифы. Новые цены не применяются к уже оплаченному периоду.',
          '4.5. Возврат денежных средств за неиспользованный оплаченный период производится по письменному заявлению Пользователя, направленному на электронную почту Исполнителя, пропорционально неиспользованным полным дням, в течение 10 рабочих дней с даты получения заявления.',
        ],
      },
      {
        h: '5. Права и обязанности сторон',
        p: [
          '5.1. Исполнитель обязуется обеспечивать работу Сервиса, кроме времени плановых работ и сбоев, вызванных третьими лицами, в том числе маркетплейсами и их API.',
          '5.2. Исполнитель вправе совершенствовать Сервис, изменять его интерфейс и набор функций.',
          '5.3. Исполнитель вправе приостановить доступ Пользователя при нарушении условий оферты, правил маркетплейса или законодательства РФ.',
          '5.4. Пользователь обязуется не передавать доступ третьим лицам, кроме добавленных им сотрудников в разделе «Команда», не пытаться получить несанкционированный доступ к Сервису и не использовать Сервис в целях, нарушающих закон или правила маркетплейсов.',
        ],
      },
      {
        h: '6. Ответственность',
        p: [
          '6.1. Расчёты Сервиса строятся на данных, которые предоставляет маркетплейс, и на данных, которые вводит Пользователь (себестоимость, налоги и т. п.). Исполнитель не отвечает за полноту, точность и своевременность данных маркетплейса, а также за изменения или недоступность API маркетплейса.',
          '6.2. Показатели Сервиса носят информационный и аналитический характер и не являются бухгалтерской, налоговой или юридической консультацией. Решения о ценах, закупках и налогах Пользователь принимает самостоятельно.',
          '6.3. Совокупная ответственность Исполнителя по договору ограничена суммой, уплаченной Пользователем за последний оплаченный период. Исполнитель не возмещает упущенную выгоду.',
          '6.4. Стороны освобождаются от ответственности при обстоятельствах непреодолимой силы.',
        ],
      },
      {
        h: '7. Персональные данные и конфиденциальность',
        p: [
          '7.1. Обработка персональных данных Пользователя ведётся в соответствии с Политикой обработки персональных данных, опубликованной в Сервисе.',
          '7.2. Исполнитель не продаёт и не передаёт третьим лицам данные магазина Пользователя, кроме случаев, предусмотренных законом.',
        ],
      },
      {
        h: '8. Срок действия и расторжение',
        p: [
          '8.1. Договор действует с момента акцепта до его расторжения.',
          '8.2. Пользователь вправе в любой момент отказаться от договора, направив заявление на электронную почту Исполнителя с адреса, указанного при регистрации. Исполнитель удаляет учётную запись и данные магазина Пользователя в течение 30 дней. Подключённый магазин Пользователь может удалить из Сервиса сам в любой момент.',
          '8.3. Споры решаются путём переговоров, а при недостижении согласия — в суде по месту нахождения Исполнителя. Претензионный порядок обязателен, срок ответа на претензию — 30 дней.',
          '8.4. Исполнитель вправе изменять оферту, публикуя новую редакцию в Сервисе. Продолжение использования Сервиса после публикации означает согласие с новой редакцией.',
        ],
      },
      {
        h: '9. Реквизиты Исполнителя',
        p: [
          `${C.fullName}`,
          `ИНН ${C.inn}, КПП ${C.kpp}, ОГРН ${C.ogrn}`,
          `Адрес: ${C.address}`,
          `Р/с ${C.bank.account} в ${C.bank.name}, БИК ${C.bank.bik}, к/с ${C.bank.corrAccount}`,
          `Генеральный директор: ${C.director}`,
          `Email: ${C.email}`,
        ],
      },
    ],
  },

  privacy: {
    path: '/legal/privacy',
    title: 'Политика обработки персональных данных',
    subtitle: `Сервис ${SERVICE}`,
    sections: [
      {
        h: '1. Общие положения',
        p: [
          `1.1. Политика составлена в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и определяет порядок обработки и защиты персональных данных пользователей сервиса ${SERVICE} (${C.site}).`,
          `1.2. Оператор персональных данных — ${C.fullName}, ИНН ${C.inn}, ОГРН ${C.ogrn}, адрес: ${C.address}. Email для обращений: ${C.email}.`,
          '1.3. Политика опубликована в открытом доступе и действует в отношении всех персональных данных, которые оператор получает от пользователей сервиса.',
        ],
      },
      {
        h: '2. Какие данные мы обрабатываем',
        p: [
          '2.1. Адрес электронной почты, пароль (хранится только в виде необратимого хеша), имя и роль сотрудников, которых пользователь добавляет в свою команду.',
          '2.2. Технические данные: IP-адрес и сведения о запросах в журналах веб-сервера, сведения о сессиях входа, необходимые для безопасности учётной записи.',
          '2.3. Данные магазина на маркетплейсе, которые сервис загружает по API-ключу пользователя: продажи, возвраты, финансовые отчёты, реклама, остатки, идентификатор продавца. Эти данные относятся к деятельности пользователя как продавца. Если в них встречаются персональные данные, они обрабатываются по правилам этой политики.',
          '2.4. Платёжные реквизиты организации или ИП, указанные для выставления счёта.',
          '2.5. Оператор не обрабатывает специальные категории персональных данных и биометрические данные.',
        ],
      },
      {
        h: '3. Цели обработки',
        p: [
          '3.1. Регистрация и вход в сервис, восстановление доступа.',
          '3.2. Исполнение договора (оферты): загрузка данных магазина и расчёт аналитики.',
          '3.3. Выставление счетов и учёт оплат.',
          '3.4. Отправка служебных писем: подтверждение почты, сброс пароля, уведомления о работе сервиса и сроке доступа.',
          '3.5. Обеспечение безопасности и предотвращение злоупотреблений.',
        ],
      },
      {
        h: '4. Правовые основания',
        p: [
          '4.1. Согласие пользователя на обработку персональных данных, которое он даёт отдельно при регистрации.',
          '4.2. Заключение и исполнение договора, стороной которого является пользователь.',
          '4.3. Исполнение обязанностей, установленных законодательством РФ (бухгалтерский и налоговый учёт).',
        ],
      },
      {
        h: '5. Как мы обрабатываем и защищаем данные',
        p: [
          '5.1. Обработка ведётся с использованием средств автоматизации: сбор, запись, систематизация, накопление, хранение, уточнение, извлечение, использование, блокирование, удаление и уничтожение.',
          '5.2. Запись, систематизация, накопление, хранение и уточнение персональных данных граждан РФ ведутся с использованием баз данных, находящихся на территории Российской Федерации.',
          '5.3. Пароли хранятся в виде хеша, API-ключи маркетплейсов — в зашифрованном виде. Ключи не передаются в браузер и не записываются в журналы. Доступ к серверам и базе данных есть только у уполномоченных сотрудников оператора.',
          '5.4. Оператор не продаёт персональные данные и не передаёт их третьим лицам, кроме случаев, предусмотренных законом, и кроме подрядчиков, обеспечивающих работу сервиса (хостинг, отправка почты), которые обязаны соблюдать конфиденциальность.',
          '5.5. Трансграничная передача персональных данных не осуществляется.',
          '5.6. Сервис использует только технически необходимое хранилище браузера для поддержания входа в учётную запись. Сторонние системы веб-аналитики и рекламные cookie не используются.',
        ],
      },
      {
        h: '6. Сроки хранения',
        p: [
          '6.1. Данные хранятся, пока действует учётная запись пользователя, либо до отзыва согласия.',
          '6.2. После удаления учётной записи или отзыва согласия данные уничтожаются в течение 30 дней, кроме сведений, которые оператор обязан хранить по закону (например, первичные бухгалтерские документы об оплате).',
        ],
      },
      {
        h: '7. Права пользователя',
        p: [
          '7.1. Пользователь вправе получить сведения об обработке своих данных, потребовать их уточнения, блокирования или уничтожения, отозвать согласие на обработку.',
          `7.2. Запрос или отзыв согласия направляется на ${C.email} с адреса, указанного при регистрации. Оператор отвечает в течение 10 рабочих дней.`,
          '7.3. Пользователь вправе обжаловать действия оператора в Роскомнадзоре или в суде.',
        ],
      },
      {
        h: '8. Изменение политики',
        p: [
          `8.1. Оператор вправе изменять политику. Новая редакция действует с момента публикации на сайте. Текущая редакция от ${LEGAL_VERSION}.`,
        ],
      },
    ],
  },

  consent: {
    path: '/legal/consent',
    title: 'Согласие на обработку персональных данных',
    subtitle: `Сервис ${SERVICE}`,
    sections: [
      {
        h: '',
        p: [
          `Регистрируясь в сервисе ${SERVICE} и отмечая соответствующий пункт, я свободно, своей волей и в своём интересе даю ${C.fullName} (ИНН ${C.inn}, ОГРН ${C.ogrn}, адрес: ${C.address}), далее «Оператор», согласие на обработку моих персональных данных на следующих условиях.`,
          '1. Перечень данных: адрес электронной почты; IP-адрес и сведения о входах в сервис; данные магазина на маркетплейсе, загружаемые по моему API-ключу, в части, относящейся к персональным данным; реквизиты для выставления счёта.',
          '2. Цели: регистрация и предоставление доступа к сервису, исполнение договора-оферты, расчёт аналитики, выставление счетов, направление служебных писем, обеспечение безопасности учётной записи.',
          '3. Действия с данными: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, блокирование, удаление, уничтожение. Обработка ведётся с использованием средств автоматизации.',
          '4. Оператор может поручить обработку подрядчикам, обеспечивающим работу сервиса (хостинг, отправка почты), с обязательством соблюдать конфиденциальность.',
          '5. Согласие действует до удаления учётной записи или до его отзыва. Отзыв направляется письмом на адрес ' + C.email + ' с почты, указанной при регистрации. После отзыва Оператор прекращает обработку и уничтожает данные в течение 30 дней, кроме случаев, когда хранение требуется по закону.',
          '6. Я ознакомлен(а) с Политикой обработки персональных данных Оператора.',
        ],
      },
    ],
  },

  requisites: {
    path: '/legal/requisites',
    title: 'Реквизиты и контакты',
    subtitle: SERVICE,
    sections: [
      {
        h: 'Компания',
        p: [
          C.fullName,
          `ИНН ${C.inn}`,
          `КПП ${C.kpp}`,
          `ОГРН ${C.ogrn}`,
          `Юридический адрес: ${C.address}`,
          `Генеральный директор: ${C.director}`,
        ],
      },
      {
        h: 'Банковские реквизиты',
        p: [
          `Расчётный счёт: ${C.bank.account}`,
          `Банк: ${C.bank.name}`,
          `БИК: ${C.bank.bik}`,
          `Корреспондентский счёт: ${C.bank.corrAccount}`,
        ],
      },
      {
        h: 'Связь',
        p: [`Email: ${C.email}`, `Сайт: ${C.site}`],
      },
      {
        h: '',
        p: [`${SERVICE} не является продуктом Wildberries, Ozon или Яндекс Маркета.`],
      },
    ],
  },
};

export const LEGAL_LINKS = [
  { to: LEGAL_DOCS.offer.path, label: 'Оферта' },
  { to: LEGAL_DOCS.privacy.path, label: 'Политика конфиденциальности' },
  { to: LEGAL_DOCS.consent.path, label: 'Согласие на обработку данных' },
  { to: LEGAL_DOCS.requisites.path, label: 'Реквизиты' },
];
